import useHttpQuery from 'data/firestore/useHttpQuery';

const useAppointments = <T = unknown>() => useHttpQuery<T>({
    pathname: '/appointments',
});

export default useAppointments;
